<template>
  <svg class="stroke-current w-8 h-8 mr-1 md:mr-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43.64 55.23"><g fill="none"><path d="M9.16.5h14.19a5.25 5.25 0 0 1 5.26 5.26v8.5H3.89v-8.5A5.25 5.25 0 0 1 9.15.5zM.5 14.26h31.36v5.49H.5zm27.34 5.49l-1 5.16a3.08 3.08 0 0 1-3 2.47H8.63a3.07 3.07 0 0 1-3-2.53l-.92-5.1z"/><path d="M9.92 27.38v8.45l-4.68 1.82a.9.9 0 0 0-.53.85v1.66a.89.89 0 0 0 .88.9H10v10.7a2.94 2.94 0 0 0 2.23 2.91 2.85 2.85 0 0 0 3.34-2.17l5.82-25.14zM3.89 43.6v9.73m6.03-4.86h-6"/><path  d="M20.37 31.62h5.93v4.21m-.3 0a2.64 2.64 0 0 1 2.64 2.64v4A2.64 2.64 0 0 1 26 45.11a2.64 2.64 0 0 1-2.64-2.64v-4A2.64 2.64 0 0 1 26 35.83zm17.14-11.54a2.64 2.64 0 0 1-2.64 2.64h-4a2.64 2.64 0 0 1-2.64-2.64 2.64 2.64 0 0 1 2.64-2.64h4a2.64 2.64 0 0 1 2.64 2.64zm-16.34 0h7.06"/><path d="M8 .5v5.87M11.27.5v5.87M14.59.5v5.87M17.91.5v5.87M21.23.5v5.87M24.55.5v5.87"/><path d="M8 10.56h6.64m3.36 0h6.64"/></g></svg>
</template>

<script>
export default {

};
</script>

<style>

</style>
